import { useParams } from 'react-router-dom'
import { apiCall } from '@api/resources/apiCall'
import { skipToken } from '@reduxjs/toolkit/query'

export function useMission() {
  const { missionId } = useParams()

  const {
    data: mission,
    isLoading: isMissionLoading,
    isError
  } = apiCall.useMissionsControllerFindByIdQuery(missionId ? [missionId] : skipToken)

  let missionError = ''

  if (!mission && isError) {
    missionError = `Миссия с id ${missionId || 'unknown'} не найдена`
  }

  return { mission, isMissionLoading, missionError }
}
